module.exports = __webpack_public_path__ + "img/@tmp_kv.c9777a24.jpg";